"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateGuid = generateGuid;
exports.getGuid = getGuid;

function generateGuid() {
  return 'xyy-yxxy-yyx'.replace(/[xy]/g, c => {
    // eslint-disable-next-line no-bitwise
    const r = Math.random() * 16 | 0; // eslint-disable-next-line no-bitwise

    const v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
} // get guid for the new caption from options or generate if need


function getGuid(options) {
  if (options && Object.prototype.hasOwnProperty.call(options, 'guid')) {
    return options.guid;
  }

  return generateGuid();
}